"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DetailedRating", {
  enumerable: true,
  get: function () {
    return _DetailedRating.DetailedRating;
  }
});
Object.defineProperty(exports, "DetailedRatingData", {
  enumerable: true,
  get: function () {
    return _DetailedRating.DetailedRatingData;
  }
});
var _DetailedRating = require("./DetailedRating");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfRGV0YWlsZWRSYXRpbmciLCJyZXF1aXJlIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRGV0YWlsZWRSYXRpbmcvaW5kZXgudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IERldGFpbGVkUmF0aW5nLCBEZXRhaWxlZFJhdGluZ0RhdGEgfSBmcm9tIFwiLi9EZXRhaWxlZFJhdGluZ1wiXG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsSUFBQUEsZUFBQSxHQUFBQyxPQUFBIiwiaWdub3JlTGlzdCI6W119